import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=6093b35a&scoped=true&lang=pug&"
import script from "./regist.vue?vue&type=script&lang=js&"
export * from "./regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093b35a",
  null
  
)

export default component.exports